import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
var FbIcon = function(param) {
    var to = param.to;
    return /*#__PURE__*/ _jsx(Link, {
        href: to,
        target: "_blank",
        children: /*#__PURE__*/ _jsxs("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ _jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.99984 16.667C13.6818 16.667 16.6665 13.6822 16.6665 10.0003C16.6665 6.31843 13.6818 3.33366 9.99984 3.33366C6.31794 3.33366 3.33317 6.31843 3.33317 10.0003C3.33317 13.6822 6.31794 16.667 9.99984 16.667ZM9.99984 18.3337C14.6022 18.3337 18.3332 14.6027 18.3332 10.0003C18.3332 5.39795 14.6022 1.66699 9.99984 1.66699C5.39746 1.66699 1.6665 5.39795 1.6665 10.0003C1.6665 14.6027 5.39746 18.3337 9.99984 18.3337Z",
                    fill: "#777E91"
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M9.99984 8.33301C9.99984 7.87277 10.3729 7.49967 10.8332 7.49967H11.6665C12.1268 7.49967 12.4998 7.12658 12.4998 6.66634C12.4998 6.20611 12.1268 5.83301 11.6665 5.83301H10.8332C9.45242 5.83301 8.33317 6.9523 8.33317 8.33301V9.99967H7.49984C7.0396 9.99967 6.6665 10.3728 6.6665 10.833C6.6665 11.2933 7.0396 11.6663 7.49984 11.6663H8.33317V16.6663C8.33317 17.1266 8.70625 17.4997 9.1665 17.4997C9.62675 17.4997 9.99984 17.1266 9.99984 16.6663V11.6663H11.6665C12.1268 11.6663 12.4998 11.2933 12.4998 10.833C12.4998 10.3728 12.1268 9.99967 11.6665 9.99967H9.99984V8.33301Z",
                    fill: "#777E91"
                })
            ]
        })
    });
};
export default FbIcon;
var Link = styled.a.withConfig({
    componentId: "sc-495ef350-0"
})(_templateObject());
